import React, { useEffect, useRef, useState } from 'react';

import './Login.css';
import { LoginService } from '../services/LoginService';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';
import { STARTER_API } from '../ApiNames';
import { Link } from 'react-router-dom';
import { Message } from 'primereact/message';
import { Toast } from 'primereact/toast';
import { useLocation, useParams } from 'react-router-dom';
import * as Yup from 'yup';
import AppSettings from '../services/AppSettings';


var imageName = require('./../assets/img/mdcal.png');



interface LoginData {
    username: string;
    password: string;
    email: string;
    usertype: string;
    checked: any;
}

// export const Login = () => {


function Login() {
    const [username, setUsername] = useState('');
    const [useremail, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [checked, setChecked] = useState(false);
    const [userData, setUserData] = useState<LoginData[]>([]);
    const navigate = useNavigate();
    const toast = useRef<Toast | null>(null);
    const [globalFilter, setGlobalFilter] = useState('');
    const [iframeUrl, setIframeUrl] = useState('');

    useEffect(() => {
        AppSettings.BASE_URL();
    }, []);

    const validationSchemas = Yup.object().shape({
        useremail: Yup.string().email('Invalid email address').required('Email address is required'),
        password: Yup.string().required('Password is required')
    });

    const validationSchema = Yup.object().shape({
        username: Yup.string()
            .max(30, 'Username must be at most 30 characters')
            .required('First name is required'),
        userlname: Yup.string()
            .max(30, 'Last name must be at most 30 characters')
            .required('Last name is required'),
        useregremail: Yup.string()
            .email('Invalid email address')
            .required('Email address is required'),
        userregpassword: Yup.string().required('Password is required'),
        userphone: Yup.string()
            .matches(/^\d{10}$/, 'Phone number must be exactly 10 digits')
            .required('Phone number is required'),
    });

    const location = useLocation();
    const [queryParams, setQueryParams] = useState(null);
    const [url, setUrl] = useState<string>('');

    //   useEffect(() => {

    //     const url = `https://devrct.e-medicall.com/hybridauth/sociallogin.php`;


    //   })
    useEffect(() => {
        const fetchUrl = async () => {
            const response = await fetch('https://devrct.e-medicall.com/hybridauth/sociallogin.php');
            const data = await response.json();
            setUrl(data.url); // Assume the response contains a URL
        };

    })
    const onCheckboxChange = (e: any) => {
        setChecked(e.checked);
    };


    const handleLogin = async () => {
  try {
    const payload = { username, password };
    const apiname = STARTER_API.STARTER_LOGIN;
    const data = await LoginService.getData(apiname, payload);

	    const loginUser = Array.isArray(data) ? data[0] : data;

	    // 🔴 INVALID LOGIN
	    if (!loginUser || data === 'nouser' || typeof data === 'string') {
	      (toast.current as Toast)?.show({
	        severity: 'error',
	        summary: 'Sorry',
	        detail: 'Your Credentials Do not Match',
	      });
      return;
    }

    // ✅ VALID LOGIN
    setUserData(data);

	    const uid = loginUser?.uid;
	    const usertype = loginUser?.usertype;
	    const photo = loginUser?.photo;
	    const usernamee = loginUser?.username;
	    const status = loginUser?.status;

    sessionStorage.setItem('uid', uid);
    sessionStorage.setItem('usertype', usertype);
    sessionStorage.setItem('photo', photo);
    sessionStorage.setItem('username', usernamee);
    sessionStorage.setItem('status', status);

    // ✅ NAVIGATION
    if (sessionStorage.getItem('auth_code') === 'YES') {
      navigate('/');
      return;
    }

    switch (usertype) {
      case 'patient':
        navigate('/patientdashboard');
        break;
      case 'doctor':
        navigate('/doctorprofile');
        break;
      case 'supervisor':
        navigate('/sdashboard');
        break;
      case 'medical_officer':
        navigate('/mprofile');
        break;
      case 'patient_approver':
        navigate('/patient_approver');
        break;
      case 'doctor_approver':
        navigate('/daprofile');
        break;
      case 'consultancy_officer':
        navigate('/cprofile');
        break;
      case 'admin':
        navigate('/adashboard');
        break;
      case 'finance_officer':
        navigate('/fprofile');
        break;
      case 'assistant':
        navigate('/assistantprofile');
        break;
      default:
        navigate('/');
    }

  } catch (error) {
    (toast.current as Toast)?.show({
      severity: 'error',
      summary: 'Error',
      detail: 'Login server is not responding. Please try again later.',
    });
  }
};

    const [emailError, setEmailError] = useState({
        required: false,
        pattern: false,
    });

    const handleEmailChange = (e: any) => {
        const value = e.target.value;
        setUsername(value);

        // Validate required
        const isRequired = value.trim() === '';
        // Validate email format using regex
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isPatternValid = emailPattern.test(value);

        // Update error state
        setEmailError({
            required: isRequired,
            pattern: !isRequired && !isPatternValid,
        });
    };
    const [passwordError, setPasswordError] = useState('');

    const handlePasswordChange = (e: any) => {
        const value = e.target.value;
        setPassword(value);

        if (!/[a-zA-Z]/.test(value) || !/\d/.test(value)) {
            setPasswordError('Password must contain both letters and numbers.');
        } else {
            setPasswordError(''); // Clear error if valid
        }
    };
    const [isChecked, setIsChecked] = useState(false);
    const handleCheckboxChange = (e: any) => {
        setIsChecked(e.target.checked);
    };


    const headerStyle: React.CSSProperties = {
        width: '100%',
        height: '50px',
        backgroundColor: 'rgb(78, 84, 83)',
        position: 'fixed',
        top: 0,
        left: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        zIndex: 1000,
    };
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/doctorlogin.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (
        <>
            {/* <div style={headerStyle}>
      <p>Header</p>
    </div> */}
            <div className="main-body flex justify-content-center align-items-center" style={{ flexDirection: 'column', minHeight: '100vh' }}>
                <div className="w-full flex justify-content-end mb-3">
                    <a
                        title="Help"
                        onClick={(e) => openWindow(e, IUrl)}
                        style={{
                            color: "blue",
                            fontSize: 15,
                            cursor: "pointer",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px"
                        }}
                    >
                        Help for this Page
                        <i
                            className="pi pi-question-circle"
                            style={{
                                backgroundColor: "orange",
                                color: "white",
                                borderRadius: "50%",
                                padding: "3px"
                            }}
                        ></i>
                    </a>
                </div>

                {/* Logo Section */}
                <div className="logo-container mb-4" style={{ display: 'flex', justifyContent: 'center', minWidth: '220px' }}>
                    <img src={imageName} alt="Logo" width="220px" style={{ width: '320px' }} />
                </div>

                {/* Login Box */}
                <div className="surface-card p-4 shadow-2 border-round w-full lg:w-4">
                    <div className="text-center mb-5">
                        <div className="text-900 text-3x font-medium mb-3">
                            <h2 style={{ color: 'rgb(102, 102, 102)', fontSize: '20px', fontWeight: '400' }}>
                                Sign in to start your session
                            </h2>
                        </div>
                    </div>
                    <div>
                        <div className="grid" style={{ position: 'relative' }}>
                            <label htmlFor="email" className="block text-900 font-medium mb-2">Email</label>
                            <div style={{ position: 'relative', width: '100%' }}>
                                <InputText
                                    id="email"
                                    type="text"
                                    placeholder="Email address"
                                    className="w-full mb-1 pr-5"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                />
                                <i className="pi pi-envelope" style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', color: '#888' }} />
                            </div>
                            {/* Error message */}
                            <div hidden={!emailError.required} style={{ color: 'white', fontWeight: '400', backgroundColor: '#dc3545', marginLeft: '20px', height: '23px', alignItems: 'center', width: '420px', borderRadius: '10px', paddingTop: '2px' }}>
                                Invalid Email Format: Please enter a valid email address
                            </div>
                        </div>

                        <br />
                        <div className="grid" style={{ position: 'relative' }}>
                            <label htmlFor="password" className="block text-900 font-medium mb-2">Password</label>
                            <div style={{ position: 'relative', width: '100%' }}>
                                <InputText
                                    id="password"
                                    type="password"
                                    placeholder="Password"
                                    className="w-full mb-1 pr-5"
                                    value={password}
                                    onChange={handlePasswordChange}
                                />
                                {/* Lock icon */}
                                <i className="pi pi-lock" style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', color: '#888' }} />
                            </div>
                            {/* Error message */}
                            {passwordError && (
                                <div style={{ color: 'white', fontWeight: '400', backgroundColor: '#dc3545', marginLeft: '30px', height: '23px', alignItems: 'center', width: '400px', borderRadius: '10px', paddingTop: '2px' }}>
                                    {passwordError}
                                </div>
                            )}
                        </div>

                        <div className="p-field-checkbox" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
                            {/* Checkbox on the left */}
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <input
                                    type="checkbox"
                                    id="remember"
                                    checked={isChecked}
                                    onChange={handleCheckboxChange}
                                    style={{ marginRight: '10px' }}
                                />
                                <label htmlFor="terms" className="p-checkbox-label"><span style={{ color: 'rgb(102, 102, 102)', fontWeight: '900', fontFamily: 'Source Sans Pro, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", Segoe UI Symbol', fontSize: '18px' }}>Remember Me</span></label>
                            </div>

                            {/* Sign Up Button on the right */}
                            <Button
                                label="Sign In"
                                style={{ backgroundColor: 'rgb(0, 105, 217)', marginTop: '20px', color: '#fff', }}
                                onClick={handleLogin}
                                icon="pi pi-user"
                                text raised
                            />
                        </div>

                        {/* Spacing below the button */}
                        <div style={{ marginBottom: '30px' }} />
                        <Button
                            icon="pi pi-twitter"
                            style={{ width: '50px', backgroundColor: '#31b0d5', color: 'white', border: 'none', borderRadius: '5px', marginLeft: '8px' }}

                        />
                        <Button
                            icon="pi pi-facebook"
                            style={{ width: '50px', backgroundColor: 'rgb(32, 77, 116)', color: 'white', border: 'none', borderRadius: '5px', marginLeft: '8px' }}

                        />
                        <Button
                            icon="pi pi-google"
                            style={{ width: '50px', backgroundColor: 'rgb(172, 41, 37)', color: 'white', border: 'none', borderRadius: '5px', marginLeft: '8px' }}

                        />
                        <Button
                            icon="pi pi-linkedin"
                            style={{ width: '50px', backgroundColor: 'rgb(32, 77, 116)', color: 'white', border: 'none', borderRadius: '5px', marginLeft: '8px' }}

                        />
                        {/* Forgot Password Link */}
                        <div style={{ textAlign: 'left', marginTop: '20px' }}>
                            <Link to="/forgetpassword" style={{ textDecoration: 'none', color: 'rgb(0, 86, 179)' }}>Forgot your password?</Link>
                        </div>

                        {/* Don't have an account section */}
                        <div style={{ textAlign: 'left', marginTop: '20px' }}>
                            <Link to="/register" style={{ textDecoration: 'none', color: 'rgb(0, 86, 179)' }}>Register a new membership</Link>
                        </div>

                    </div>
                </div>
            </div>
            <Toast ref={toast} ></Toast>

        </>
    );
}
export default Login
